export default "__VITE_ASSET__Cga0fP9b__"